/* Velomora theme UI: countdown, header, PDP gallery/variants, sticky bar,
   video carousel, dialogs, collection sort, recommendation fetching.
   Uses event delegation so re-rendered fragments keep working. */
(function () {
  'use strict';

  /* ---------- helpers ---------- */
  var moneyFormat = window.vmMoneyFormat || '{{ amount }}';

  function formatMoney(cents) {
    var amount = cents / 100;
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = moneyFormat.match(placeholder);
    var key = match ? match[1] : 'amount';
    switch (key) {
      case 'amount_no_decimals':
      case 'amount_no_decimals_with_comma_separator':
      case 'amount_no_decimals_with_space_separator':
        value = new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 }).format(Math.round(amount));
        break;
      default:
        value = new Intl.NumberFormat('en-IN', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(amount);
        value = value.replace(/\.00$/, '');
    }
    return moneyFormat.replace(placeholder, value);
  }

  window.vmFormatMoney = formatMoney;

  /* ---------- announcement countdown (to next local midnight) ---------- */
  function initCountdowns(root) {
    (root || document).querySelectorAll('[data-vm-countdown]').forEach(function (el) {
      if (el.vmTicking) return;
      el.vmTicking = true;
      var pad = function (n) {
        return String(n).padStart(2, '0');
      };
      var tick = function () {
        var now = new Date();
        var end = new Date(now);
        end.setHours(24, 0, 0, 0);
        var d = Math.max(0, end - now);
        el.textContent =
          pad(Math.floor(d / 3.6e6)) + ':' + pad(Math.floor((d % 3.6e6) / 6e4)) + ':' + pad(Math.floor((d % 6e4) / 1e3));
      };
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------- header mobile menu ---------- */
  document.addEventListener('click', function (e) {
    var burger = e.target.closest('[data-vm-burger]');
    if (!burger) return;
    var panel = document.getElementById('VmMobileMenu');
    if (!panel) return;
    var open = panel.classList.toggle('is-open');
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ---------- dialogs ---------- */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-vm-dialog-open]');
    if (opener) {
      var dialog = document.getElementById(opener.getAttribute('data-vm-dialog-open'));
      if (dialog) {
        dialog.hidden = false;
        document.body.classList.add('vm-lock');
      }
      return;
    }
    var closer = e.target.closest('[data-vm-dialog-close]');
    if (closer) {
      var overlay = closer.closest('.vm-dialog-overlay');
      if (overlay) {
        overlay.hidden = true;
        document.body.classList.remove('vm-lock');
      }
      return;
    }
    if (e.target.classList && e.target.classList.contains('vm-dialog-overlay')) {
      e.target.hidden = true;
      document.body.classList.remove('vm-lock');
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.vm-dialog-overlay:not([hidden])').forEach(function (overlay) {
      overlay.hidden = true;
      document.body.classList.remove('vm-lock');
    });
  });

  /* ---------- collection sort ---------- */
  document.addEventListener('change', function (e) {
    var sort = e.target.closest('[data-vm-sort]');
    if (!sort) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sort.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* ---------- PDP gallery (scroll-snap carousel) ---------- */
  function gallerySync(gallery, index) {
    gallery.dataset.vmIndex = index;
    gallery.querySelectorAll('[data-vm-slide]').forEach(function (slide) {
      slide.classList.toggle('is-active', Number(slide.getAttribute('data-index')) === index);
    });
    gallery.querySelectorAll('[data-vm-thumb]').forEach(function (thumb) {
      thumb.classList.toggle('is-active', Number(thumb.getAttribute('data-index')) === index);
    });
  }

  function galleryGo(gallery, index) {
    var track = gallery.querySelector('[data-vm-gallery-track]');
    var slides = gallery.querySelectorAll('[data-vm-slide]');
    if (!track || !slides.length) return;
    var count = slides.length;
    index = ((index % count) + count) % count;
    gallerySync(gallery, index);
    track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
  }

  function initGalleryTracks(root) {
    (root || document).querySelectorAll('[data-vm-gallery-track]').forEach(function (track) {
      if (track.vmBound) return;
      track.vmBound = true;
      var gallery = track.closest('[data-vm-gallery]');
      var ticking = false;
      track.addEventListener(
        'scroll',
        function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            ticking = false;
            var index = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
            if (Number(gallery.dataset.vmIndex || 0) !== index) gallerySync(gallery, index);
          });
        },
        { passive: true }
      );
    });
  }

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-vm-thumb]');
    if (thumb) {
      galleryGo(thumb.closest('[data-vm-gallery]'), Number(thumb.getAttribute('data-index')));
      return;
    }
    var prev = e.target.closest('[data-vm-gallery-prev]');
    if (prev) {
      var g1 = prev.closest('[data-vm-gallery]');
      galleryGo(g1, Number(g1.dataset.vmIndex || 0) - 1);
      return;
    }
    var next = e.target.closest('[data-vm-gallery-next]');
    if (next) {
      var g2 = next.closest('[data-vm-gallery]');
      galleryGo(g2, Number(g2.dataset.vmIndex || 0) + 1);
    }
  });

  /* ---------- PDP variant picker + quantity ---------- */
  function productRoot(el) {
    return el.closest('[data-vm-product]');
  }

  function getVariants(root) {
    if (root.vmVariants) return root.vmVariants;
    var script = root.querySelector('[data-vm-variants]');
    root.vmVariants = script ? JSON.parse(script.textContent) : [];
    return root.vmVariants;
  }

  function currentQty(root) {
    var input = root.querySelector('[data-vm-qty]');
    return input ? Math.max(1, parseInt(input.value, 10) || 1) : 1;
  }

  /* the FBT/product-card forms inside the section carry their own
     input[name="id"]: always target the main buy form's tagged input */
  function variantIdInput(root) {
    return root.querySelector('[data-vm-id-input]') || root.querySelector('input[name="id"]');
  }

  function currentVariant(root) {
    var variants = getVariants(root);
    var id = variantIdInput(root);
    if (!id) return null;
    return (
      variants.find(function (v) {
        return String(v.id) === String(id.value);
      }) || null
    );
  }

  function syncBuyUI(root) {
    var variant = currentVariant(root);
    var qty = currentQty(root);
    var strings = window.vmStrings || {};

    root.querySelectorAll('[data-vm-qty-num]').forEach(function (el) {
      el.textContent = qty;
    });

    /* Fastrr's Buy now reads quantity from its own form, not the main one */
    root.querySelectorAll('[data-vm-sr-qty]').forEach(function (el) {
      el.value = qty;
    });

    if (!variant) return;

    root.querySelectorAll('[data-vm-price]').forEach(function (el) {
      el.textContent = formatMoney(variant.price);
    });
    root.querySelectorAll('[data-vm-compare]').forEach(function (el) {
      var show = variant.compare_at_price && variant.compare_at_price > variant.price;
      el.classList.toggle('vm-hidden', !show);
      if (show) el.textContent = formatMoney(variant.compare_at_price);
    });
    root.querySelectorAll('[data-vm-off]').forEach(function (el) {
      var show = variant.compare_at_price && variant.compare_at_price > variant.price;
      el.classList.toggle('vm-hidden', !show);
      if (show) {
        var pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
        el.textContent = (strings.percentOff || '[pct]% off').replace('[pct]', pct);
      }
    });

    var atcLabel = root.querySelector('[data-vm-atc-label]');
    if (atcLabel) {
      atcLabel.textContent = variant.available
        ? (strings.addToCartPrice || 'Add to cart: [price]').replace('[price]', formatMoney(variant.price * qty))
        : strings.soldOut || 'Sold out';
    }
    root.querySelectorAll('[data-vm-atc-btn], [data-vm-buy-now]').forEach(function (btn) {
      btn.disabled = !variant.available;
    });

    /* Shiprocket Checkout (Fastrr) reads the variant from its own form's
       id input; keep it in sync and hide its button slot when sold out */
    root.querySelectorAll('[data-vm-sr-id]').forEach(function (el) {
      el.value = variant.id;
    });
    var srSlot = root.querySelector('.shiprocket-headless');
    if (srSlot) srSlot.classList.toggle('vm-hidden', !variant.available);
  }

  document.addEventListener('click', function (e) {
    var root;

    var minus = e.target.closest('[data-vm-qty-minus]');
    var plus = e.target.closest('[data-vm-qty-plus]');
    if (minus || plus) {
      root = productRoot(minus || plus);
      if (!root) return;
      var input = root.querySelector('[data-vm-qty]');
      var qty = Math.max(1, (parseInt(input.value, 10) || 1) + (plus ? 1 : -1));
      input.value = qty;
      syncBuyUI(root);
      return;
    }

    var optionBtn = e.target.closest('[data-vm-option]');
    if (optionBtn) {
      root = productRoot(optionBtn);
      if (!root) return;
      var group = optionBtn.closest('[data-vm-option-group]');
      group.querySelectorAll('[data-vm-option]').forEach(function (btn) {
        btn.classList.toggle('is-selected', btn === optionBtn);
      });
      var valueLabel = group.querySelector('[data-vm-option-value]');
      if (valueLabel) valueLabel.textContent = optionBtn.getAttribute('data-value');

      var selected = [];
      root.querySelectorAll('[data-vm-option-group]').forEach(function (grp) {
        var sel = grp.querySelector('[data-vm-option].is-selected');
        selected.push(sel ? sel.getAttribute('data-value') : null);
      });
      var variant = getVariants(root).find(function (v) {
        return v.options.every(function (opt, i) {
          return opt === selected[i];
        });
      });
      var idInput = variantIdInput(root);
      if (variant && idInput) {
        idInput.value = variant.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      syncBuyUI(root);
      return;
    }

    var stickyAdd = e.target.closest('[data-vm-sticky-add]');
    if (stickyAdd) {
      var form = document.getElementById(stickyAdd.getAttribute('data-vm-sticky-add'));
      if (form) {
        form.vmTriggerBtn = stickyAdd;
        form.requestSubmit();
      }
    }
  });

  /* ---------- search modal + recently viewed ---------- */
  var RECENT_KEY = 'vm:recently-viewed';

  function readRecent() {
    try {
      return JSON.parse(localStorage.getItem(RECENT_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function trackRecentProduct(root) {
    var script = (root || document).querySelector('[data-vm-recent-product]');
    if (!script) return;
    try {
      var item = JSON.parse(script.textContent);
      var items = readRecent().filter(function (it) {
        return it.handle !== item.handle;
      });
      items.unshift(item);
      localStorage.setItem(RECENT_KEY, JSON.stringify(items.slice(0, 8)));
    } catch (e) {
      /* storage unavailable */
    }
  }

  function searchRow(item) {
    var row = document.createElement('a');
    row.className = 'vm-search__row';
    row.href = item.url;
    var img = document.createElement('img');
    img.src = item.image || '';
    img.alt = '';
    img.width = 48;
    img.height = 48;
    img.loading = 'lazy';
    if (!item.image) img.classList.add('vm-hidden');
    var info = document.createElement('span');
    info.className = 'vm-search__rowinfo';
    var title = document.createElement('span');
    title.className = 'vm-search__rowtitle';
    title.textContent = item.title;
    var price = document.createElement('span');
    price.className = 'vm-search__rowprice';
    price.textContent = item.price || '';
    info.appendChild(title);
    info.appendChild(price);
    row.appendChild(img);
    row.appendChild(info);
    return row;
  }

  function renderRecent() {
    var wrap = document.querySelector('[data-vm-search-recent]');
    var list = document.querySelector('[data-vm-search-recent-list]');
    if (!wrap || !list) return;
    var items = readRecent();
    list.innerHTML = '';
    wrap.hidden = items.length === 0;
    items.forEach(function (item) {
      list.appendChild(searchRow(item));
    });
  }

  var searchDebounce;

  function runSearch(query) {
    var results = document.querySelector('[data-vm-search-results]');
    var recent = document.querySelector('[data-vm-search-recent]');
    if (!results) return;
    var strings = window.vmStrings || {};

    if (query.length < 2) {
      results.innerHTML = '';
      renderRecent();
      return;
    }
    if (recent) recent.hidden = true;

    var url =
      '/search/suggest.json?q=' +
      encodeURIComponent(query) +
      '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
    fetch(url)
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        var input = document.querySelector('[data-vm-search-input]');
        if (!input || input.value.trim() !== query) return;
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        results.innerHTML = '';
        products.forEach(function (p) {
          results.appendChild(
            searchRow({
              url: p.url,
              title: p.title,
              image: p.featured_image && p.featured_image.url,
              price: p.price ? formatMoney(Math.round(parseFloat(p.price) * 100)) : '',
            })
          );
        });
        var all = document.createElement('a');
        all.className = 'vm-search__all';
        all.href = window.routes.predictive_search_url
          ? '/search?q=' + encodeURIComponent(query) + '&options%5Bprefix%5D=last'
          : '/search?q=' + encodeURIComponent(query);
        all.textContent = products.length
          ? (strings.searchAll || 'See all results for “[q]”').replace('[q]', query)
: (strings.searchNone || 'No products for “[q]”: search everything').replace('[q]', query);
        results.appendChild(all);
      })
      .catch(function () {
        /* leave as-is */
      });
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-vm-search-open]');
    if (!opener) return;
    var modal = document.getElementById('VmSearch');
    if (!modal) return;
    e.preventDefault();
    modal.hidden = false;
    document.body.classList.add('vm-lock');
    renderRecent();
    var input = modal.querySelector('[data-vm-search-input]');
    if (input) {
      input.focus();
      runSearch(input.value.trim());
    }
  });

  document.addEventListener('input', function (e) {
    var input = e.target.closest('[data-vm-search-input]');
    if (!input) return;
    clearTimeout(searchDebounce);
    searchDebounce = setTimeout(function () {
      runSearch(input.value.trim());
    }, 220);
  });

  /* ---------- PDP image lightbox ---------- */
  var lightbox = {
    slides: [],
    index: 0,
    el: function () {
      return document.getElementById('VmLightbox');
    },
    open: function (gallery, index) {
      var lb = this.el();
      if (!lb) return;
      this.slides = Array.prototype.slice
        .call(gallery.querySelectorAll('[data-vm-slide][data-vm-zoom-src]'))
        .map(function (slide) {
          return slide.getAttribute('data-vm-zoom-src');
        });
      if (!this.slides.length) return;
      this.index = Math.max(0, Math.min(index, this.slides.length - 1));
      this.render();
      lb.hidden = false;
      document.body.classList.add('vm-lock');
      var close = lb.querySelector('[data-vm-dialog-close]');
      if (close) close.focus();
    },
    render: function () {
      var lb = this.el();
      if (!lb) return;
      var img = lb.querySelector('[data-vm-lightbox-img]');
      img.src = this.slides[this.index];
      var count = lb.querySelector('[data-vm-lightbox-count]');
      if (count) count.textContent = this.index + 1 + ' / ' + this.slides.length;
      var single = this.slides.length < 2;
      lb.querySelectorAll('[data-vm-lightbox-prev], [data-vm-lightbox-next]').forEach(function (btn) {
        btn.classList.toggle('vm-hidden', single);
      });
    },
    step: function (dir) {
      var count = this.slides.length;
      if (!count) return;
      this.index = (this.index + dir + count) % count;
      this.render();
    },
  };

  document.addEventListener('click', function (e) {
    var zoomImg = e.target.closest('[data-vm-gallery] [data-vm-slide][data-vm-zoom-src] img');
    if (zoomImg) {
      var slide = zoomImg.closest('[data-vm-slide]');
      lightbox.open(slide.closest('[data-vm-gallery]'), Number(slide.getAttribute('data-index')) || 0);
      return;
    }
    if (e.target.closest('[data-vm-lightbox-prev]')) {
      lightbox.step(-1);
      return;
    }
    if (e.target.closest('[data-vm-lightbox-next]')) {
      lightbox.step(1);
    }
  });

  document.addEventListener('keydown', function (e) {
    var lb = document.getElementById('VmLightbox');
    if (!lb || lb.hidden) return;
    if (e.key === 'ArrowLeft') lightbox.step(-1);
    if (e.key === 'ArrowRight') lightbox.step(1);
  });

  /* ---------- sticky add-to-cart bar ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-vm-sticky]');
    if (!bar || bar.vmBound) return;
    bar.vmBound = true;
    var onScroll = function () {
      bar.classList.toggle('is-visible', window.scrollY > 640);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- reel-style video rail ---------- */
  function reelStep(track) {
    var card = track.querySelector('[data-vm-reel]');
    return card ? card.getBoundingClientRect().width + 10 : track.clientWidth / 3;
  }

  function initVideoCarousels(root) {
    (root || document).querySelectorAll('[data-vm-videos]').forEach(function (wrap) {
      if (wrap.vmBound) return;
      wrap.vmBound = true;
      var track = wrap.querySelector('[data-vm-videos-track]');
      if (!track) return;

      var pauseUntil = 0;
      var hovering = false;
      var railInView = false;
      wrap.addEventListener('mouseenter', function () {
        hovering = true;
      });
      wrap.addEventListener('mouseleave', function () {
        hovering = false;
      });
      track.addEventListener(
        'pointerdown',
        function () {
          pauseUntil = Date.now() + 8000;
        },
        { passive: true }
      );

      wrap.addEventListener('click', function (e) {
        var prev = e.target.closest('[data-vm-videos-prev]');
        var next = e.target.closest('[data-vm-videos-next]');
        if (!prev && !next) return;
        pauseUntil = Date.now() + 8000;
        track.scrollBy({ left: (next ? 1 : -1) * reelStep(track), behavior: 'smooth' });
      });

      /* only the reels in view play; also track rail visibility for auto-scroll */
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              var video = entry.target.querySelector('video');
              if (!video) return;
              if (entry.intersectionRatio >= 0.6) {
                video.play().catch(function () {});
              } else {
                video.pause();
              }
            });
          },
          { threshold: [0, 0.6, 1] }
        );
        track.querySelectorAll('[data-vm-reel]').forEach(function (reel) {
          io.observe(reel);
        });

        new IntersectionObserver(
          function (entries) {
            railInView = entries[0].isIntersecting;
          },
          { threshold: 0.3 }
        ).observe(wrap);
      }

      /* auto-advance one card at a time */
      var reelCount = track.querySelectorAll('[data-vm-reel]').length;
      if (reelCount > 3 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        setInterval(function () {
          if (hovering || document.hidden || !railInView || Date.now() < pauseUntil) return;
          var viewer = document.getElementById('VmReelViewer');
          if (viewer && !viewer.hidden) return;
          var maxScroll = track.scrollWidth - track.clientWidth;
          if (track.scrollLeft >= maxScroll - 4) {
            track.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            track.scrollBy({ left: reelStep(track), behavior: 'smooth' });
          }
        }, 3500);
      }
    });
  }

  /* ---------- reel viewer: vertical snap feed, Instagram-style ----------
     One full-height slide per video; swiping/scrolling snaps between them
     and an IntersectionObserver plays only the active slide. */
  var reelViewer = {
    index: 0,
    muted: false,
    el: function () {
      return document.getElementById('VmReelViewer');
    },
    feed: function () {
      var el = this.el();
      return el && el.querySelector('[data-vm-reelviewer-feed]');
    },
    slides: function () {
      var feed = this.feed();
      return feed ? Array.prototype.slice.call(feed.children) : [];
    },
    video: function () {
      var slide = this.slides()[this.index];
      return slide && slide.querySelector('video');
    },
    open: function (track, index) {
      var el = this.el();
      var feed = this.feed();
      if (!el || !feed) return;
      var sources = Array.prototype.slice.call(track.querySelectorAll('[data-vm-reel] video')).map(function (v) {
        return v.currentSrc || v.src;
      });
      if (!sources.length) return;
      this.build(sources);
      this.index = Math.max(0, Math.min(index, sources.length - 1));
      this.muted = false;
      el.hidden = false;
      document.body.classList.add('vm-lock');
      var single = sources.length < 2;
      el.querySelectorAll('[data-vm-reelviewer-prev], [data-vm-reelviewer-next]').forEach(function (btn) {
        btn.classList.toggle('vm-hidden', single);
      });
      var slides = this.slides();
      slides[this.index].scrollIntoView({ block: 'start', behavior: 'instant' in feed ? 'auto' : 'auto' });
      feed.scrollTop = this.index * feed.clientHeight;
      this.activate(this.index, true);
    },
    build: function (sources) {
      var self = this;
      var feed = this.feed();
      if (feed.dataset.built === sources.join('|')) return;
      feed.dataset.built = sources.join('|');
      feed.innerHTML = '';
      sources.forEach(function (src) {
        var slide = document.createElement('div');
        slide.className = 'vm-reelviewer__slide';
        var video = document.createElement('video');
        video.className = 'vm-reelviewer__video';
        video.src = src;
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        video.loop = true;
        video.preload = 'metadata';
        var pausedIcon = document.createElement('span');
        pausedIcon.className = 'vm-reelviewer__pausedicon';
        pausedIcon.innerHTML =
          '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><polygon points="6 3 20 12 6 21 6 3"/></svg>';
        slide.appendChild(video);
        slide.appendChild(pausedIcon);
        feed.appendChild(slide);
        video.addEventListener('play', function () {
          slide.classList.remove('is-paused');
          self.syncButtons();
        });
        video.addEventListener('pause', function () {
          slide.classList.add('is-paused');
          self.syncButtons();
        });
      });
      if (this.feedObserver) this.feedObserver.disconnect();
      this.feedObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.intersectionRatio < 0.6) {
              var v = entry.target.querySelector('video');
              if (v) v.pause();
              return;
            }
            self.activate(self.slides().indexOf(entry.target), false);
          });
        },
        { root: feed, threshold: [0, 0.6] }
      );
      this.slides().forEach(function (slide) {
        self.feedObserver.observe(slide);
      });
    },
    activate: function (index, firstOpen) {
      if (index < 0) return;
      var self = this;
      this.index = index;
      var video = this.video();
      if (!video) return;
      var el = this.el();
      video.muted = this.muted;
      video.currentTime = video.currentTime || 0;
      video
        .play()
        .then(function () {
          self.syncButtons();
        })
        .catch(function () {
          if (firstOpen && !video.muted) {
            /* unmuted autoplay blocked: fall back to muted */
            self.muted = true;
            video.muted = true;
            video.play().catch(function () {});
          }
          self.syncButtons();
        });
      var count = el.querySelector('[data-vm-reelviewer-count]');
      if (count) count.textContent = this.index + 1 + ' / ' + this.slides().length;
    },
    syncButtons: function () {
      var el = this.el();
      if (!el || el.hidden) return;
      var video = this.video();
      if (!video) return;
      var muteBtn = el.querySelector('[data-vm-reelviewer-mute]');
      if (muteBtn) {
        muteBtn.querySelector('.vm-reel__ic-on').classList.toggle('vm-hidden', video.muted);
        muteBtn.querySelector('.vm-reel__ic-off').classList.toggle('vm-hidden', !video.muted);
        muteBtn.setAttribute(
          'aria-label',
          video.muted ? muteBtn.getAttribute('data-label-unmute') : muteBtn.getAttribute('data-label-mute')
        );
      }
    },
    step: function (dir) {
      var feed = this.feed();
      if (!feed) return;
      feed.scrollBy({ top: dir * feed.clientHeight, behavior: 'smooth' });
    },
    togglePlay: function () {
      var video = this.video();
      if (!video) return;
      if (video.paused) video.play().catch(function () {});
      else video.pause();
    },
    toggleMute: function () {
      this.muted = !this.muted;
      var video = this.video();
      if (video) video.muted = this.muted;
      this.syncButtons();
    },
    stop: function () {
      this.slides().forEach(function (slide) {
        var v = slide.querySelector('video');
        if (v) v.pause();
      });
    },
  };

  document.addEventListener('click', function (e) {
    /* rail mute buttons */
    var mute = e.target.closest('[data-vm-reel-mute]:not([data-vm-reelviewer-mute])');
    if (mute) {
      var reelM = mute.closest('[data-vm-reel]');
      var videoM = reelM && reelM.querySelector('video');
      if (!videoM) return;
      videoM.muted = !videoM.muted;
      mute.querySelector('.vm-reel__ic-off').classList.toggle('vm-hidden', !videoM.muted);
      mute.querySelector('.vm-reel__ic-on').classList.toggle('vm-hidden', videoM.muted);
      mute.setAttribute(
        'aria-label',
        videoM.muted ? mute.getAttribute('data-label-unmute') : mute.getAttribute('data-label-mute')
      );
      return;
    }

    /* click a reel -> open the viewer */
    var reelVideo = e.target.closest('[data-vm-reel] video');
    if (reelVideo) {
      var track = reelVideo.closest('[data-vm-videos-track]');
      var reels = Array.prototype.slice.call(track.querySelectorAll('[data-vm-reel]'));
      reelViewer.open(track, reels.indexOf(reelVideo.closest('[data-vm-reel]')));
      return;
    }

    /* viewer controls */
    if (e.target.closest('[data-vm-reelviewer-prev]')) {
      reelViewer.step(-1);
      return;
    }
    if (e.target.closest('[data-vm-reelviewer-next]')) {
      reelViewer.step(1);
      return;
    }
    if (e.target.closest('[data-vm-reelviewer-mute]')) {
      reelViewer.toggleMute();
      return;
    }
    /* tap the active video toggles play/pause */
    if (e.target.closest('.vm-reelviewer__slide video')) {
      reelViewer.togglePlay();
      return;
    }
    /* click the letterbox around a slide (desktop) closes the viewer */
    var slide = e.target.closest('.vm-reelviewer__slide');
    if (slide) {
      var viewerEl = reelViewer.el();
      viewerEl.hidden = true;
      document.body.classList.remove('vm-lock');
      reelViewer.stop();
      return;
    }

    /* after the shared dialog handlers hide the viewer, stop playback */
    var viewer = document.getElementById('VmReelViewer');
    if (viewer && viewer.hidden) reelViewer.stop();
  });

  document.addEventListener('keydown', function (e) {
    var viewer = document.getElementById('VmReelViewer');
    if (!viewer) return;
    if (e.key === 'Escape' && viewer.hidden) {
      reelViewer.stop();
      return;
    }
    if (viewer.hidden) return;
    if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
      e.preventDefault();
      reelViewer.step(-1);
    }
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
      e.preventDefault();
      reelViewer.step(1);
    }
    if (e.key === ' ') {
      e.preventDefault();
      reelViewer.togglePlay();
    }
  });

  /* ---------- recommendations (FBT + popular this week) ---------- */
  function initRecommendations(root) {
    (root || document).querySelectorAll('[data-vm-recs][data-url]').forEach(function (host) {
      if (host.vmLoaded) return;
      host.vmLoaded = true;
      fetch(host.getAttribute('data-url'))
        .then(function (res) {
          return res.text();
        })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var content = doc.querySelector('[data-vm-recs-content]');
          var wrap = host.closest('[data-vm-recs-wrap]');
          if (content && content.children.length) {
            host.innerHTML = content.innerHTML;
            if (wrap) wrap.classList.remove('vm-hidden');
          } else if (wrap) {
            wrap.classList.add('vm-hidden');
          }
        })
        .catch(function () {
          var wrap = host.closest('[data-vm-recs-wrap]');
          if (wrap) wrap.classList.add('vm-hidden');
        });
    });
  }

  /* ---------- logo strip: color + enlarge the logo passing center ---------- */
  function initLogoSpotlights(root) {
    (root || document).querySelectorAll('[data-vm-logospot]').forEach(function (strip) {
      if (strip.vmSpot) return;
      strip.vmSpot = true;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var logos = strip.querySelectorAll('.vm-logostrip__logo');
      var running = false;
      /* plain strips rest in full color: spotlight only scales them */
      var fullColor = !!strip.closest('.vm-logostrip--plain');
      var staticMq = strip.classList.contains('vm-logostrip__viewport--mobile')
        ? window.matchMedia('(min-width: 750px)')
        : null;

      function spotlightFilter(t) {
        return 'grayscale(' + (1 - t).toFixed(3) + ') opacity(' + (0.55 + 0.45 * t).toFixed(3) + ')';
      }

      function clearStyles() {
        logos.forEach(function (logo) {
          logo.style.transform = '';
          if (logo.firstElementChild) logo.firstElementChild.style.filter = '';
        });
      }

      if (staticMq) staticMq.addEventListener('change', clearStyles);

      function frame() {
        if (!running || !strip.isConnected) return;
        if (staticMq && staticMq.matches) {
          window.requestAnimationFrame(frame);
          return;
        }
        var rect = strip.getBoundingClientRect();
        var center = rect.left + rect.width / 2;
        var reach = Math.max(rect.width / 6, 120);
        logos.forEach(function (logo) {
          var r = logo.getBoundingClientRect();
          var t = Math.max(0, 1 - Math.abs(r.left + r.width / 2 - center) / reach);
          logo.style.transform = 'scale(' + (1 + 0.25 * t).toFixed(3) + ')';
          var img = logo.firstElementChild;
          if (img && !fullColor) img.style.filter = spotlightFilter(t);
        });
        window.requestAnimationFrame(frame);
      }

      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting === running) return;
          running = entry.isIntersecting;
          if (running) window.requestAnimationFrame(frame);
        });
      }).observe(strip);
    });
  }

  /* ---------- logo strip: one-time staggered reveal for static rows ---------- */
  function initLogoReveals(root) {
    var revealTargets =
      '.vm-logostrip__row, .vm-logostrip__viewport--mobile .vm-logostrip__group:not([aria-hidden])';
    (root || document).querySelectorAll(revealTargets).forEach(function (row) {
      if (row.vmReveal) return;
      row.vmReveal = true;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      row.classList.add('vm-reveal');
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            row.classList.add('vm-reveal--in');
            io.disconnect();
          });
        },
        { threshold: 0.3 }
      );
      io.observe(row);
    });
  }

  /* ---------- one-time rise-in reveal (footer giant wordmark) ---------- */
  function initRises(root) {
    (root || document).querySelectorAll('[data-vm-rise]').forEach(function (el) {
      if (el.vmRise) return;
      el.vmRise = true;
      el.classList.add('vm-rise');
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            el.classList.add('vm-rise--in');
            io.disconnect();
          });
        },
        { threshold: 0.35 }
      );
      io.observe(el);
    });
  }

  /* ---------- Judge.me guards: stop review-widget scroll jumps ---------- */
  function initJudgemeGuards() {
    if (document.vmJdgmGuard) return;
    document.vmJdgmGuard = true;

    /* Their photo lightbox locks <body> (position:fixed) and restores the
       scroll position on close with an instant scrollTo, which our global
       scroll-behavior:smooth would animate across the whole page. Force
       instant scrolling while the lightbox is open and briefly after. */
    new MutationObserver(function () {
      if (document.body.classList.contains('jm-mfp-is-open')) {
        document.documentElement.style.scrollBehavior = 'auto';
      } else if (document.documentElement.style.scrollBehavior === 'auto') {
        setTimeout(function () {
          document.documentElement.style.scrollBehavior = '';
        }, 400);
      }
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

    /* Pagination swaps the review list for a short spinner, collapsing the
       widget (~750px) and yanking the page up. Hold the current height
       until the next page's reviews are rendered. */
    /* capture phase: Judge.me stops propagation on pagination clicks */
    document.addEventListener(
      'click',
      function (e) {
        if (!e.target.closest) return;
        var pager = e.target.closest('.jdgm-paginate a, .jdgm-paginate__page');
        if (!pager) return;
        var widg = pager.closest('.jdgm-rev-widg');
        if (!widg) return;
        widg.style.minHeight = widg.getBoundingClientRect().height + 'px';
        var sawEmpty = false;
        var release = function () {
          widg.style.minHeight = '';
          obs.disconnect();
          clearTimeout(timer);
        };
        var timer = setTimeout(release, 5000);
        var obs = new MutationObserver(function () {
          if (!widg.querySelector('.jdgm-rev')) {
            sawEmpty = true;
            return;
          }
          if (sawEmpty) window.requestAnimationFrame(release);
        });
        obs.observe(widg, { childList: true, subtree: true });
      },
      true
    );
  }

  /* ---------- product video spotlight ----------
     Single portrait video beside editorial text. Plays only while in view,
     tap toggles play/pause, and the corner button toggles sound. */
  function initProductVideos(root) {
    (root || document).querySelectorAll('[data-vm-pvideo]').forEach(function (frame) {
      if (frame.vmBound) return;
      frame.vmBound = true;
      var video = frame.querySelector('video');
      if (!video) return;

      var reflectPaused = function () {
        frame.classList.toggle('is-paused', video.paused);
      };
      video.addEventListener('play', reflectPaused);
      video.addEventListener('pause', reflectPaused);

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        video.removeAttribute('autoplay');
        video.pause();
        reflectPaused();
      } else if ('IntersectionObserver' in window) {
        new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (frame.vmUserPaused) return;
              if (entry.intersectionRatio >= 0.4) {
                video.play().catch(function () {});
              } else {
                video.pause();
              }
            });
          },
          { threshold: [0, 0.4, 1] }
        ).observe(frame);
      }

      video.addEventListener('click', function () {
        frame.vmUserPaused = !video.paused;
        if (video.paused) {
          video.play().catch(function () {});
        } else {
          video.pause();
        }
      });

      var mute = frame.querySelector('[data-vm-pvideo-mute]');
      if (mute) {
        mute.addEventListener('click', function () {
          video.muted = !video.muted;
          mute.querySelector('.vm-pvideo__ic-off').classList.toggle('vm-hidden', !video.muted);
          mute.querySelector('.vm-pvideo__ic-on').classList.toggle('vm-hidden', video.muted);
          mute.setAttribute(
            'aria-label',
            video.muted ? mute.getAttribute('data-label-unmute') : mute.getAttribute('data-label-mute')
          );
        });
      }
    });
  }

  /* ---------- init ---------- */
  function init(root) {
    initCountdowns(root);
    initSticky();
    initVideoCarousels(root);
    initProductVideos(root);
    initRecommendations(root);
    initGalleryTracks(root);
    initLogoSpotlights(root);
    initLogoReveals(root);
    initRises(root);
    initJudgemeGuards();
    trackRecentProduct(root);
    document.querySelectorAll('[data-vm-product]').forEach(syncBuyUI);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
